import { InjectionToken, Injectable } from '@angular/core';
import { getNumeral } from './numeral';

export const NUMERAL: InjectionToken<any> = new InjectionToken('numeral');

@Injectable()
export class NumeralRef {
    get nativeNumeral(): any {
        return getNumeral();
    }
}

export const NUMERAL_PROVIDERS = [
    { provide: NumeralRef, useClass: NumeralRef },
    { provide: NUMERAL, useFactory: getNumeral, deps: [] }
];
